type Options = {
  payload: string;
  className?: string;
};

export default function Description({ payload, className }: Options) {
  return (
    <div
      className={`text-title-2-regular text-neutral-600 max-sm:text-label-2-regular ${className}`}
    >
      {payload}
    </div>
  );
}
